import styled from 'styled-components';

export const LogoDivider = styled.div`
  width: 0rem;
  height: ${props => props.theme.space.s3};
  border-right: ${props => props.theme.borderWidths.small} solid #657a94;
  margin: ${props => props.theme.space.none} ${props => props.theme.space.s5};
  ${props => props.theme.mediaQueries.smallDown} {
    margin: ${props => props.theme.space.none} ${props => props.theme.space.s3};
  }
`;
